import { FileLinkField } from 'admin/fields/FileLinkField';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { Role, useCurrentUserQuery } from 'generated/graphql';
import { useContext } from 'react';
import {
  BooleanField,
  Datagrid,
  DateField,
  DeleteButton,
  EditButton,
  ReferenceField,
  SelectField,
  TextField,
} from 'react-admin';

import { REPORT_TYPE_CHOICES } from './reportUtils';

interface ReportDatagridProps {
  showClient?: boolean;
}

export const ReportDatagrid: React.FC<ReportDatagridProps> = ({ showClient = true }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const { data } = useCurrentUserQuery({ skip: !isAuthenticated });

  const hasAnyRole = (allowedRoles: Role[]) =>
    isAuthenticated && data?.user?.roles?.some((role: Role) => allowedRoles.includes(role));

  const showEditButton = hasAnyRole([Role.RoleFinancialAdvisor, Role.RoleAdmin]);
  const showDeleteButton = hasAnyRole([Role.RoleFinancialAdvisor, Role.RoleAdmin]);

  return (
    <Datagrid bulkActionButtons={false} rowClick="show">
      <TextField label="ID" source="id" />
      {showClient && (
        <ReferenceField label="Klient" link="show" reference="Client" source="client.id">
          <TextField source="user.email" />
        </ReferenceField>
      )}
      <SelectField choices={REPORT_TYPE_CHOICES} label="Typ" source="type" />
      <BooleanField label="Publikované" source="published" />
      <DateField label="Dátum vytvorenia" locales="sk" source="creationTimestamp" />
      <DateField label="Dátum zmeny" locales="sk" source="updateTimestamp" />
      <FileLinkField label="Výstup" source="file.id" />
      {showEditButton && <EditButton />}
      {showDeleteButton && <DeleteButton mutationMode="pessimistic" />}
    </Datagrid>
  );
};
